// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file telemetry/v1alpha/telemetry.proto (package com.seed.telemetry.v1alpha, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";

/**
 * A single checkpoint stamp.
 *
 * @generated from message com.seed.telemetry.v1alpha.Checkpoint
 */
export class Checkpoint extends Message<Checkpoint> {
  /**
   * Correlation key. Always an hm:// URL with a version pin:
   *   hm://<account>/<path>?v=<version_cid>
   * The path segment is optional but the ?v= pin is always present, so that
   * the new-blob path keys uniquely on the arriving blob and the user-fetch
   * path keys on the requested version.
   *
   * @generated from field: string key = 1;
   */
  key = "";

  /**
   * Canonical stage name, e.g. "renderer.refetch_start". See the package
   * documentation in backend/api/telemetry/v1alpha for the full list and the
   * initiating/continuing classification rules.
   *
   * @generated from field: string stage = 2;
   */
  stage = "";

  /**
   * Unix nanoseconds. Wall-clock from whichever process is emitting; clock
   * skew between daemon and Electron processes is acceptable for the
   * sub-second resolutions we care about, but consumers should expect a few
   * ms of drift.
   *
   * @generated from field: int64 ts_unix_nanos = 3;
   */
  tsUnixNanos = protoInt64.zero;

  constructor(data?: PartialMessage<Checkpoint>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.telemetry.v1alpha.Checkpoint";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "stage", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "ts_unix_nanos", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Checkpoint {
    return new Checkpoint().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Checkpoint {
    return new Checkpoint().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Checkpoint {
    return new Checkpoint().fromJsonString(jsonString, options);
  }

  static equals(a: Checkpoint | PlainMessage<Checkpoint> | undefined, b: Checkpoint | PlainMessage<Checkpoint> | undefined): boolean {
    return proto3.util.equals(Checkpoint, a, b);
  }
}

/**
 * Request to record a batch of checkpoints.
 *
 * @generated from message com.seed.telemetry.v1alpha.RecordCheckpointsRequest
 */
export class RecordCheckpointsRequest extends Message<RecordCheckpointsRequest> {
  /**
   * The source process that produced these checkpoints. Free-form, mainly
   * useful for debugging the profiler itself ("main", "renderer:<windowId>").
   *
   * @generated from field: string source = 1;
   */
  source = "";

  /**
   * The checkpoints, in the order they were observed by the emitter.
   *
   * @generated from field: repeated com.seed.telemetry.v1alpha.Checkpoint checkpoints = 2;
   */
  checkpoints: Checkpoint[] = [];

  constructor(data?: PartialMessage<RecordCheckpointsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.telemetry.v1alpha.RecordCheckpointsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "checkpoints", kind: "message", T: Checkpoint, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RecordCheckpointsRequest {
    return new RecordCheckpointsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RecordCheckpointsRequest {
    return new RecordCheckpointsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RecordCheckpointsRequest {
    return new RecordCheckpointsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: RecordCheckpointsRequest | PlainMessage<RecordCheckpointsRequest> | undefined, b: RecordCheckpointsRequest | PlainMessage<RecordCheckpointsRequest> | undefined): boolean {
    return proto3.util.equals(RecordCheckpointsRequest, a, b);
  }
}

/**
 * Empty response.
 *
 * @generated from message com.seed.telemetry.v1alpha.RecordCheckpointsResponse
 */
export class RecordCheckpointsResponse extends Message<RecordCheckpointsResponse> {
  constructor(data?: PartialMessage<RecordCheckpointsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.telemetry.v1alpha.RecordCheckpointsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RecordCheckpointsResponse {
    return new RecordCheckpointsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RecordCheckpointsResponse {
    return new RecordCheckpointsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RecordCheckpointsResponse {
    return new RecordCheckpointsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: RecordCheckpointsResponse | PlainMessage<RecordCheckpointsResponse> | undefined, b: RecordCheckpointsResponse | PlainMessage<RecordCheckpointsResponse> | undefined): boolean {
    return proto3.util.equals(RecordCheckpointsResponse, a, b);
  }
}

